const AssetTypeSVG = ({
  svg,
  size = 18,
  color = "#000000",
  fill = "#000000",
}) => {
  return (
    <svg
      viewBox="0 0 18 12"
      fill="none"
      width="16"
      height="16"
      xlmns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.29412 5.79545L11.6471 3.75L6.35294 7.84091L9.17647 15L18 0L0 0L5.29412 5.79545Z"
      ></path>
    </svg>
  );
};

export default AssetTypeSVG;
